import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import AdminPage from './pages/AdminPage';
import ComingSoon from './pages/ComingSoon';
import AuthConfirm from './pages/AuthConfirm';
import MarketingVideo from './pages/MarketingVideo';
import ProtectedRoute from './components/ProtectedRoute';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import { VoiceProvider } from './context/VoiceContext';
import DemoModeBanner from './components/DemoModeBanner';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import { isDemoMode } from './services/supabase';

function App() {
  return (
    <ErrorBoundary>
      <FeatureFlagsProvider>
        <VoiceProvider>
          <Router>
            <div className="app">
              {isDemoMode && <DemoModeBanner />}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route
                  path="/dashboard/*"
                  element={
                    <ProtectedRoute requiredRole="student">
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/*"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
                {/* Marketing demo video */}
                <Route path="/demo" element={<MarketingVideo />} />
                {/* Email confirmation link handler */}
                <Route path="/auth/confirm" element={<AuthConfirm />} />
                {/* Catch-all: any unknown / unimplemented route */}
                <Route path="*" element={<ComingSoon />} />
              </Routes>
              <Footer />
            </div>
          </Router>
        </VoiceProvider>
      </FeatureFlagsProvider>
    </ErrorBoundary>
  );
}

export default App;
